import { Injectable } from '@angular/core';
import { CognitoUserPool, CognitoUserAttribute, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js'
import { BehaviorSubject, from } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { LoaderService } from './loader.service';
import { UtilitiesService } from './utilities.service';
import { HttpService } from '../services/http.service';
import { CommonService } from '../services/common/common.service';

@Injectable({
  providedIn: 'root'
})
export class CognitoServiceService {

  // Data of particular pool of cognito-user-pools
  poolData = {
    UserPoolId: 'ap-south-1_rZMEKbUjj',
    ClientId: '2o03al6h9mh9c0i0932iqlvcf5'
  };
  userPool = new CognitoUserPool(this.poolData);
  locData = {};
  ip: string;
  ipaddress;

  constructor(
    private loader: LoaderService, 
    private http: HttpClient, 
    private utils: UtilitiesService,
    private httpService : HttpService,
    private commonService : CommonService,
    private router: Router,
    ) {
    }

  /**
   * @desc To signup user using cognito user pool
   * @param  {object} userData consists user's name, email, phone, password data
   * @param  {function} callback to call after successful signup
   * @returns void
   */
  doSignup(userData, callback): void {
    var that = this;

    this.loader.toggleLoader(true); // Show Loader

    var userPool = new CognitoUserPool(this.poolData);

    // Preparing data for signup
    var attrList = [];
    var dataEmail = { Name: 'email', Value: userData.email };
    var dataPhoneNumber = { Name: 'phone_number', Value: this.commonService.phoneExtension + userData.phone_number };
    var dataname = { Name: 'name', Value: userData.name };
    attrList.push(new CognitoUserAttribute(dataEmail));
    attrList.push(new CognitoUserAttribute(dataPhoneNumber));
    attrList.push(new CognitoUserAttribute(dataname));

    userPool.signUp(userData.username, userData.password, attrList, null, (err, result: any) => {
      that.loader.toggleLoader(false); // Hide Loader

      // If error, notifying user and asking to signup again
      if (err) {
        that.showGlobalMessage(err.message || JSON.stringify(err));
        return;
      }
      // If success, storing the data in AA-database
      var data: any = result;
      
      var obj = {};
      obj['userId'] = data.userSub;
      obj['firstName'] = userData.name;
      //For now there is now provision to enter MiddleName and LastName, TODO: once available we need to change here
      obj['middleName'] = "";
      obj['lastName'] = "";
      obj['vua'] = userData.username + this.commonService.vuaExtension;
      obj['consentPin'] = userData.consentPin;
      obj['email'] = dataEmail.Value;
      obj['mobile'] = dataPhoneNumber.Value;
      obj['termsAndConditions'] = userData.confirmation;
      obj['type'] = "signupdata";

      let options = {
        type: 'post',
        url: 'userInfo',
        data: obj
      }
      this.httpService.makeHttpRequest(options).subscribe(res => {
        callback(result);
      });

    })
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalMessage(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }
    if(body=='User already exists'){
      popuptext.body = "Vua already exists please choose another one.";
    }

    this.commonService.showGlobalMessage(popuptext);
  }

  userAlreadyExistsAlert() {
    this.showGlobalMessage("Email is not availble, try with something else..");
  }


  /**
   * @desc To Check the user email existance in cognito user pool
   * @param  {} data consists of email to check existance
   * @param  {} callback to call after if no user
   * @returns void
   */
  checkUserEmailExistance(data, callback): void {
    var that = this;
    var email = data.email;

    // Show Loader
    this.loader.toggleLoader(true);

    // Preparing data for signin
    var authenticationData = {
      Username: email,
      Password: "randomPwd@@123",
    };
    var authdet = new AuthenticationDetails(authenticationData);
    var userPool = new CognitoUserPool(this.poolData);
    var userDetails: any = {
      Username: email,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userDetails);

    // Making signin call
    cognitoUser.authenticateUser(authdet, {
      onSuccess(result) {
        // Hide Loader
        that.loader.toggleLoader(false);
        that.userAlreadyExistsAlert();
      },
      onFailure(err) {
        // Hide Loader
        that.loader.toggleLoader(false);
        if (err.code == "UserNotFoundException") {
          callback();
        } else {
          that.userAlreadyExistsAlert();
        }
      },
      mfaRequired(res) {
        that.userAlreadyExistsAlert();
      },
      newPasswordRequired(res, req) {
        that.userAlreadyExistsAlert();
      }
    });
  }


  /**
   * @desc To signin user to the application using cognito user pool
   * @param  {} userData consists user's userName, password data
   * @param  {} callback to call after successful signin
   * @param  {} confirmMail to confirm strong entity mobile/email
   * @param  {} MFA to make MFA
   * @returns void
   */
  signin(userData, callback, confirmMail, MFA): void {

    var that = this;

    // Show Loader
    this.loader.toggleLoader(true);

    // Preparing data for signin
    var authenticationData = {
      Username: userData.userName,
      Password: userData.password,
    };
    var authdet = new AuthenticationDetails(authenticationData);
    var userPool = new CognitoUserPool(this.poolData);
    var userDetails: any = {
      Username: userData.userName,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userDetails);

    // Making signin call
    cognitoUser.authenticateUser(authdet, {
      onSuccess(result) {
        // Hide Loader
        that.loader.toggleLoader(false);

        that.storeUserSessionDataInDB(cognitoUser, callback);

      },
      onFailure(err) {
        // Hide Loader
        that.loader.toggleLoader(false);

        // If user-not-confirmed error, asking for OTP confirmation which is sent to strong-user-entity(mobile/email)
        if (err.code == "UserNotConfirmedException") {
          // var code = prompt("enter verification code");
          // that.verify(userData, code, () => { });
          that.resendConfirmationCode(userData, (res) => {
            confirmMail(userData);
          })
        } else {
          that.showGlobalMessage(err.message + ". Please try again...");
        }
      },
      mfaRequired(res) {
        // Hide Loader
        that.loader.toggleLoader(false);
        MFA(userData, cognitoUser, () => {
          that.storeUserSessionDataInDB(cognitoUser, callback);
        });
        
      },
      newPasswordRequired(res, req) {
        // If a user is created by Admin, then this is triggered to give a new password as then a dummy password is created.

        // Hide Loader
        that.loader.toggleLoader(false);
        const attrList: CognitoUserAttribute[] = [];
        // TODO: Change email to be dynamic
        const emailAttribute = {
          Name: 'email',
          Value: "saikumar@divami.com"
        };
        attrList.push(new CognitoUserAttribute(emailAttribute));

        // TODO: use custom popup
        var newPassword = prompt("Please enter your new password...", "");
        cognitoUser.completeNewPasswordChallenge(newPassword, attrList, {
          onSuccess: function (result) {
            // TODO: use custom notifier
            that.showGlobalMessage("Successfully Changed Password...");
          },
          onFailure: function (error) {
            // TODO: use custom notifier
            that.showGlobalMessage("Something  went wrong. Please try again...");
            console.error(error.message)
          }
        });
      }
    });
  }

  MFAAuthentication(userData, cognitoUser, pin, callback) {
    var userPool = new CognitoUserPool(this.poolData);
    var userDetails: any = {
      Username: userData.userName,
      Pool: userPool
    };
    // var cognitoUser = userPool.getCurrentUser();
    cognitoUser.sendMFACode(pin, {
      onSuccess: (res) => {
        console.log(res, "resssssssssssssssssss");
        callback(false);
      },
      onFailure: (err) => {
        console.log(err, "errrrrrrrrrrrrrrrrrrrrrr");
        callback(true);
      }
    })
  }

  /**
   * @desc To verify the user with verification code sent to his email address after successful signup
   * @param  {object} userDetails contains user-name of the user
   */
  verify(userDetails, code, callback) {
    var that = this;
    var userPool = new CognitoUserPool(this.poolData);
    var userData: any = {
      Username: userDetails.userName,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.confirmRegistration(code, true, (err, res)=> {
      if (err) {
        // TODO: use custom notifier 
        that.showGlobalMessage(err.message);
      } else {
        // TODO: use custom notifier
        that.showGlobalMessage("Successfully verified your Mobile...");
        callback();
      }
    });
  }

  resendConfirmationCode(userDetails, callback) {
    var that = this;
    var userPool = new CognitoUserPool(this.poolData);
    var userData: any = {
      Username: userDetails.userName,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.resendConfirmationCode(function(err, result) {
      if (err) {
        that.showGlobalMessage(err.message || JSON.stringify(err));
        return;
      }
      console.log('call result: ' + result);
      that.showGlobalMessage(`Confirmation code sent to your registered mobile. Please check`);
      callback();
  });
  }

  /**
   * @desc To return the auth status of the current user
   * @returns any (authenticated ? user data object : null)
   */
  getAuthenticatedUser(): any {
    return this.userPool.getCurrentUser();
  }

  getUserData(callback): any {
    var that = this;
    var username = this.getAuthenticatedUser().username;
    var userPool = new CognitoUserPool(this.poolData);
    var userData: any = {
      Username: username,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userData);

    // To get the session
    cognitoUser.getSession(function (err, session) {
      if (err) {
        that.showGlobalMessage(err);
        return;
      }
    });
    cognitoUser.getUserData(function (err, userData) {
      if (err) {
        that.showGlobalMessage(err.message || JSON.stringify(err));
        return;
      }
      callback(userData);
    });
  }

  dashboardRedirection(){
    let options = {
      type: 'get',
      url: 'dashboard',
      includeUserSession: true,
      isDeveloper:true
    }
    this.httpService.makeHttpRequest(options).subscribe(res => {
      if (res['bankAccounts']) {
        if (res['bankAccounts'].length > 0) {
          this.router.navigate(['/dashboard']);
        } else {
          localStorage.setItem('newUser', 'true');
          this.router.navigate(["/account-list"]);
        }
      }
    });
  }

  /**
   * @desc To signout the user from application
   * @param  {function} callback
   */
  signout(callback) {
    if (this.getAuthenticatedUser()) {
      var username = this.getAuthenticatedUser().username;
      var userPool = new CognitoUserPool(this.poolData);
      var userData: any = {
        Username: username,
        Pool: userPool
      };
      var cognitoUser = new CognitoUser(userData);
      this.utils.removeItemFromLocalStorage('usersession');
      cognitoUser.signOut();
      callback(true);
    } else {
      callback(false);
    }
  }

  /**
   * @desc To update user attributes
   * @param  {} userData
   * @param  {} callback
   */
  updateUserAttributes(userData, callback) {
    var that = this;
    var attributeList = [];
    var name = {
      Name: "name",
      Value: userData.name
    };
    var mail = {
      Name: "email",
      Value: userData.email
    };
    var phone = {
      Name: "phone_number",
      Value:  this.commonService.phoneExtension + userData.phone_number
    };
    attributeList.push(new CognitoUserAttribute(name));
    attributeList.push(new CognitoUserAttribute(mail));
    attributeList.push(new CognitoUserAttribute(phone));

    var username = this.getAuthenticatedUser().username;

    var userPool = new CognitoUserPool(this.poolData);
    var userCog: any = {
      Username: username,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userCog);

    // To get the session
    cognitoUser.getSession(function (err, session) {
      if (err) {
        that.showGlobalMessage(err);
        return;
      }
    });

    cognitoUser.updateAttributes(attributeList, (err, result) => {
      if (err) {
        that.showGlobalMessage(err.message || JSON.stringify(err));
        return;
      }
      callback(result);
    });
  }

  /**
   * @desc To change password of loggedin user
   * @param  {} userObj
   * @param  {} callback
   */
  changePassword(userObj, callback) {
    var that = this;
    var username = this.getAuthenticatedUser().username;
    var userPool = new CognitoUserPool(this.poolData);
    var userData: any = {
      Username: username,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userData);

    // To get the session
    cognitoUser.getSession(function (err, session) {
      if (err) {
        that.showGlobalMessage(err);
        return;
      }
    });
    cognitoUser.changePassword(userObj.oldpassword, userObj.newpassword, function (err, result) {
      if (err) {
        that.showGlobalMessage(err.message || JSON.stringify(err));
        return;
      }
      callback(result);
    });
  }

  forgotPassword(username, callback) {
    let that = this;
    // username = username.replace('@', '.');
    // var username = this.getAuthenticatedUser().username;
    var userPool = new CognitoUserPool(this.poolData);
    var userData: any = {
      // Username: username,
      Username: username,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.forgotPassword({
      onSuccess: function (data) {
        // successfully initiated reset password request
        callback(data);
        console.log('CodeDeliveryData from forgotPassword: ' + data);
      },
      onFailure: function (err) {
        callback(false, err);
        // if (err.code == "UserNotFoundException") {
        //   callback(false, "User Not Found");
        // } else {
        //   callback(false, err);
        // }
      },
      //Optional automatic callback
      inputVerificationCode: function (data) {
        callback(data);
      }
    });
  }

  confirmPassword(username, confirmationcode, newPassword, callback) {
    var userPool = new CognitoUserPool(this.poolData);
    var userData: any = {
      // Username: username,
      Username: username,
      Pool: userPool
    };
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.confirmPassword(confirmationcode, newPassword, {
      onSuccess() {
        console.log('Password confirmed!');
        callback(true);
      },
      onFailure(err) {
        console.log('Password not confirmed!');
        callback(status, err);
      }
    });
  }
  // getSubId(){
  //   let data;
  //   return this.getUserData(function (err, result) {
  //     if (err) {
  //       return ;
  //     } else {
  //       data=result;
  //     }
  //   })
  // }

  storeUserSessionDataInDB(cognitoUser, callback) {
    var that = this;

    var userPool = new CognitoUserPool(that.poolData);
      
    var userData: any = {
      Username: cognitoUser.username,
      Pool: userPool
    };
    var cognitoUserData = userData;

    // TODO: following function is not wirking and having session issue. Need to fix it.
    // URL to convert the IP to location data
    var ip = "http://www.geoplugin.net/json.gp?ip=$$ip$$&jsoncallback";
    cognitoUser.getDevice({
      onSuccess: (success: any) => {
        // var locData = {};
        success.Device.DeviceAttributes.map((eachAttr) => {
          that.locData[eachAttr.Name] = eachAttr.Value;
        })
        that.locData['DeviceLastAuthenticatedDate'] = success.Device['DeviceLastAuthenticatedDate'];
        success.Device.DeviceAttributes['device_name']
        that.ip = ip.replace('$$ip$$', that.locData['last_ip_used']);
        that.ipaddress = that.locData['last_ip_used'];
        that.http.get(ip)
          .subscribe((data) => {
            var sessionToken;
            that.getAuthenticatedUser().getSession((err, session) => {
              sessionToken = session.getIdToken().getJwtToken();
            })

            var decodedToken = that.utils.decodeJWTToken(sessionToken);
            var sessionToken: any = that.utils.generateSessionId();
            var obj = {};
            obj['userId'] = decodedToken.sub;
            obj['loginTime'] = new Date(that.locData['DeviceLastAuthenticatedDate']);
            obj['geoCode'] = `${data['geoplugin_latitude']}, ${data['geoplugin_longitude']}`;
            obj['location'] = data['geoplugin_city'];
            obj['ip'] = that.ipaddress;
            obj['os'] = that.utils.getOS(that.locData['device_name']);
            obj['browser'] = that.utils.getBrowser(that.locData['device_name']);
            obj['app'] = that.locData['device_name'];
            obj['userSessionId'] = sessionToken;
            obj['type'] = "sessiondata";
            
            let options = {
              type: 'post',
              url: 'userInfo',
              data: obj
            }
            that.httpService.makeHttpRequest(options).subscribe(res => {
              that.utils.setItemInLocalStorage('usersession', sessionToken);
              callback();
            });
          })
      },
      onFailure: (err: Error) => {
        console.log("device", err);
      }
    });
  }

}
